<template>
  <div class="main">
    <div class="content">
      <div class="form-row-line">
        <div class="form-input-parse">
          <label for="name-input">Поселок</label>
          <select id="name-input" v-model="idVillage">
            <option
              v-for="(village, key) in villages"
              :value="village.ID"
              :key="key"
            >
              {{ village.NAME }}
            </option>
          </select>
        </div>
        <div class="form-field">
          <button @click="downloadTemplateFile">Скачать файл шаблона</button>
        </div>
      </div>
      <div class="form-row-line">
        <div class="form-field">
          <upload-file v-on:uploadComplite="updateOwners"></upload-file>
        </div>
      </div>
    </div>
    <get-owners
      v-on:owners-list-update="updateOwners"
      :update-list="updateOwnersList"
    ></get-owners>
  </div>
</template>
<script>
import config from "@/config";
import getOwners from "components/backoffice/owner/get/Owners";

export default {
  name: "MultiOwners",
  components: {
    getOwners
  },
  data() {
    return {
      url: config.backend_url,
      updateOwnersList: false,
      idVillage: 11246,
      villages: []
    };
  },
  computed: {},
  methods: {
    updateLists: function() {
      this.updateOwners();
    },
    updateOwners: function() {
      this.updateOwnersList = !this.updateOwnersList;
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xls"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    getVillages: function() {
      let self = this;
      let data = {
        url: self.url + "villages/get/",
        filter: {},
        method: "POST"
      };
      this.plants = [];
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        self.villages = data;
      });
    },
    downloadTemplateFile() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "owners/load-template/",
          responseType: "arraybuffer",
          method: "POST",
          data: {
            VILLAGE: self.idVillage
          }
        })
        .then(response => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    }
  },
  created() {
    this.getVillages();
  }
};
</script>
